module.exports = __webpack_public_path__ + "img/icon_dispense_management.06c25489.svg";